import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartBar from '../../../components/charts/ChartBar'
import ChartBarSkeleton from '../../../components/skeletons/ChartBarSkeleton'
import { ChartBarThemes } from '../../../components/charts/types/ChartBar'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { FilterEvents } from '../../../types/FilterEvents'
import { formatDateCard, formatNumber } from '../../../utils/Helpers'
import { GET_QUANTITY_OFFERS_QUEUE_STATE } from '../../../queries/events'
import { defaultFormatTimeZone } from '../../../utils/consts'

interface Bucket {
  key: string
  doc_count: number
}
const StateEvent = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_QUANTITY_OFFERS_QUEUE_STATE, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    let date: FilterEvents['date'] = {
      initialDate: '2021-01-01T03:00:00.000Z',
      finalDate: 'now/d',
      ...defaultFormatTimeZone
    }

    if (filters.date) {
      date = {
        ...filters.date,
        ...defaultFormatTimeZone
      }
    }
    getData({
      variables: { filters: { ...filters, date } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartBarSkeleton />
  if (loading || !data) return <ChartBarSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.aggregation.aggregations) return <p>No data found</p>

  const { buckets } = data.aggregation.aggregations.data
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'events-states'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    dataLabels: {
      offsetX: 65,
      formatter: (value: number) => {
        return formatNumber(value, 0, true)
      }
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return formatNumber(value, 0, true)
        }
      }
    }
  }
  const series = [{
    name: 'Eventos',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Quantidade de eventos por estado ({formatDateCard(filters.date?.initialDate, filters.date?.finalDate)})</Typography>
    <ChartBar options={options} series={series} theme={ChartBarThemes.grey} height={500} />
  </Paper>
}

export default StateEvent
